<template>
  <div>
    <el-card>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="170px"
      >
        <el-form-item label="使用类型：" class="no-lineheight">
          <el-radio-group
            v-model="sysTag"
            size="small"
            :disabled="strictEditMode"
          >
            <el-radio :label="0">优惠券</el-radio>
            <!-- <el-radio :label="1">抵用券</el-radio> -->
          </el-radio-group>
        </el-form-item>
        <!-- 全显示 -->
        <el-form-item label="使用范围：" class="no-lineheight">
          <el-radio-group
            v-model="useRank"
            size="small"
            :disabled="strictEditMode"
          >
            <el-radio
              :label="0"
              :disabled="activeTab === '2' || activeTab === '3'"
              >通用</el-radio
            >
            <el-radio
              :label="2"
              :disabled="activeTab === '2' || activeTab === '3'"
            >
              门店</el-radio
            >
            <el-radio
              :label="v.useRank"
              v-for="(v, i) in salesChannels"
              :key="i"
              >{{ v.platformName }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <!-- 仅线上券显示 -->
        <el-form-item label="优惠券类型：">
          <div class="btn-wrapper flex item-center">
            <el-radio-group
              v-model="activeTab"
              size="small"
              @change="activeTabChange"
              :disabled="strictEditMode"
            >
              <el-radio-button label="0">满减券类</el-radio-button>
              <el-radio-button label="1">兑换券</el-radio-button>
              <el-radio-button label="2" :disabled="useRank !== 1"
                >运费券</el-radio-button
              >
              <el-radio-button label="3" :disabled="useRank !== 1"
                >折扣券</el-radio-button
              >
              <el-radio-button
                label="4"
                :disabled="useRank !== 2"
                v-if="iskunming"
                >服务券</el-radio-button
              >
              <el-radio-button label="5" v-if="iskunming" :disabled="useRank != 2"
                >满量券</el-radio-button
              >
            </el-radio-group>
            <!-- <el-button
              size="small"
              :disabled="strictEditMode"
              @click="switchTab(i)"HmBatchPurchaseCycle
              v-for="(v, i) in btnList"
              :key="i"
              :type="activeTab === i ? 'primary' : ''"
              >{{ v.name }}</el-button
            > -->
          </div>
        </el-form-item>
        <!-- 全显示 -->
        <el-form-item label="名称：" prop="name" :error="couponNameError">
          <el-input
            size="small"
            :disabled="displayMode === 'detail'"
            clearable
            placeholder="请输入券名"
            v-model.trim="ruleForm.name"
            @blur="checkCouponNameValid"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="优惠券层级："
          prop="couponLevel"
          v-if="
            couponLevelList.length && (activeTab == '0' || activeTab == '5')
          "
        >
          <el-select
            size="small"
            clearable
            placeholder="选择优惠券层级"
            v-model="ruleForm.couponLevel"
            class="mr10"
            filterable
            :disabled="strictEditMode"
          >
            <el-option
              v-for="(item, i) in couponLevelList"
              :key="i"
              :label="item.itemText"
              :value="item.itemValue"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="服务卡类型："
          prop="couponModel"
          v-if="activeTab == '4'"
        >
          <el-select
            size="small"
            clearable
            placeholder="选择服务卡类型"
            v-model="ruleForm.couponModel"
            class="mr10"
            filterable
            :disabled="strictEditMode"
          >
            <el-option
              v-for="(item, i) in serviceCardTypeList"
              :key="i"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 仅线上满减与折扣券显示 -->
        <el-form-item
          label="使用门槛："
          prop="levelMin"
          v-if="
            activeTab == '0' ||
              activeTab == '3' ||
              activeTab == '4' ||
              activeTab == '5'
          "
        >
          <div v-if="activeTab == '5'">
            <el-input
              size="small"
              @input="filterGt0OrFixed('levelMin')"
              :disabled="strictEditMode"
              clearable
              placeholder="请输入件数"
              v-model.trim="ruleForm.levelMin"
            ></el-input>
            <span class="unit">件可用</span>
            <span class="form-tip">(注:使用不叠加,无门槛时满件数填0)</span>
          </div>
          <div v-else>
            <el-input
              size="small"
              @input="filterGt0OrFixed2('levelMin')"
              :disabled="strictEditMode"
              clearable
              placeholder="请输入金额"
              v-model.trim="ruleForm.levelMin"
            ></el-input>
            <span class="unit">元</span>
            <span class="form-tip">(注:使用不叠加,无门槛时满金额填0)</span>
          </div>
        </el-form-item>
        <!-- <el-form-item label="叠加使用" v-show="activeTab === 2">
          <el-checkbox v-model="addon" class="item-center"
            >允许叠加使用</el-checkbox
          >
        </el-form-item> -->
        <el-form-item label="减免金额" prop="account" v-if="activeTab != 3">
          <el-input
            size="small"
            :disabled="strictEditMode"
            @input="filterGt0OrFixed2('account')"
            clearable
            placeholder="请输入金额"
            @blur="useNumLimitChange"
            v-model.trim="ruleForm.account"
          ></el-input>
          <span class="unit">元</span>
        </el-form-item>
        <el-form-item
          label="单笔订单使用数量限制"
          prop="useNumLimit"
          v-if="activeTab == 0 || activeTab == 5"
        >
          <el-input
            size="small"
            :disabled="strictEditMode"
            @input="filterGt0OrFixed0('useNumLimit')"
            clearable
            @change="useNumLimitChange"
            placeholder="请输入数量"
            v-model.trim="ruleForm.useNumLimit"
          ></el-input>
          <span class="unit mr10">张</span>
          <span class="primary" v-if="ruleForm.useAmountLimit !== ''"
            >单笔订单最多可用{{ ruleForm.useAmountLimit }}元</span
          >
          <div class="form-item-tip">
            不填则表示不限制
          </div>
        </el-form-item>
        <el-form-item label="折扣" prop="discount" v-if="activeTab == 3">
          <el-input
            size="small"
            :disabled="strictEditMode"
            @input="filterGt0OrFixed2('discount')"
            clearable
            placeholder="请输入折扣数"
            v-model.trim="ruleForm.discount"
          ></el-input>
          <span class="unit">折</span>
        </el-form-item>
        <!-- 仅线上折扣券显示 -->
        <!-- <el-form-item
          label="折扣比率："
          v-show="activeTab === 1"
          prop="discount"
        >
          <el-input
            size="small"
            clearable
            @mousewheel.prevent.native
            type="number"
            placeholder="请输入折扣数"
            :disabled="displayMode === 'detail'"
            v-model.trim="ruleForm.discount"
          ></el-input>
          <span class="unit">折</span>
        </el-form-item>
        <el-form-item
          label="折扣上限："
          v-show="activeTab === 1"
          prop="levelMax"
        >
          <el-input
            size="small"
            clearable
            :disabled="displayMode === 'detail'"
            @mousewheel.prevent.native
            type="number"
            placeholder="请输入金额"
            v-model.trim="ruleForm.levelMax"
          ></el-input>
          <span class="unit">元</span>
          <span class="form-tip">(使用不叠加,金额必须填整数)</span>
        </el-form-item> -->
        <!-- 全显示 -->
        <el-form-item label="券号前缀：" prop="prefix">
          <el-input
            size="small"
            :disabled="strictEditMode"
            clearable
            placeholder="请输入前缀"
            v-model.trim="ruleForm.prefix"
          ></el-input>
          <span class="form-tip"
            >（注：允许使用英文大小写、数字、不得使用空格、符号，字符长度应小于10位）,</span
          >
        </el-form-item>
        <el-form-item label="券号后缀：" prop="suffix">
          <el-input
            size="small"
            :disabled="strictEditMode"
            clearable
            placeholder="请输入后缀"
            v-model.trim="ruleForm.suffix"
          ></el-input>
          <span class="form-tip"
            >（注：允许使用英文大小写、数字、不得使用空格、符号，字符长度应小于10位）,</span
          >
        </el-form-item>
        <el-form-item
          label="商品规则设置："
          class="is-required"
          v-if="activeTab != 2 && activeTab != 4"
        >
          <div class="form-item-tip" v-if="activeTab == 0 || activeTab == 5">
            注：若不设置商品规则或商品规则失效，则默认
            <strong>购买满足最小订单金额的任意商品即可使用</strong>
          </div>
          <div class="hm-form-container">
            <!-- 过滤特价商品 -->
            <div class="flex item-center" v-if="sysTag === 0">
              <el-checkbox
                :disabled="strictEditMode && !isEditMode"
                v-model="ifSpec"
                label="过滤特价商品"
              ></el-checkbox>
              <span class="form-item-tip">（注：仅管家婆有效）</span>
            </div>
            <!-- 仅禾苗主系统展示 -->
            <div class="flex flex-between" v-if="sysTag === 0">
              <hm-transfer
                ref="ruleTransfer"
                showUseable
                :disabled="strictEditMode && !isEditMode"
                :showBarcode="true"
                showAttribute
                :isVouchers="activeTab == '1' && !isEditMode"
                :leftOption="leftRules"
                :isEditMode="isEditMode"
              ></hm-transfer>
            </div>
            <!-- 仅服务产品展示 -->
            <div class="flex flex-between" v-if="sysTag === 1">
              <hm-goods-picker
                :disabled="displayMode === 'detail'"
                :isPreview="strictEditMode"
                sysTag="service"
                ref="serveiceGoods"
                title="服务产品"
                buttonText="选择服务产品"
              ></hm-goods-picker>
            </div>
          </div>
        </el-form-item>
        <div style="margin-top: 2rem">
          <hm-date-select
            :disabled="displayMode === 'detail'"
            :isPreview="strictEditMode"
            :disableSwitchTime="disableSwitchTime"
            title="使用"
            multipleTime
            ref="hmDateSelect"
            @switchRuleDateAndTime="switchRuleDateAndTime"
            @switchUseImmediately="switchUseImmediately"
            @switchUseIntime="switchUseIntime"
            @switchRuleDate="switchRuleDate"
            @switchTimeType="switchTimeType"
            @addUseTime="addUseTime"
            @deleteUseTime="deleteUseTime"
          ></hm-date-select>
        </div>
        <!-- 券显示 -->
        <el-form-item label="会员类型：">
          <el-radio-group v-model="target" :disabled="strictEditMode">
            <el-radio :label="1">全部会员</el-radio>
            <el-radio :label="0">PLUS会员</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 仅线上券显示 -->
        <el-form-item label="每人每次领取限制：" prop="fetchLimitNum">
          每人：
          <el-input
            size="small"
            @mousewheel.prevent.native
            clearable
            type="number"
            v-model.trim="ruleForm.fetchLimitNum"
          ></el-input>
          <span class="unit">张</span>
        </el-form-item>
        <el-form-item label="券墙分类：" v-if="tabList && tabList.length > 0">
          <div class="set-tag">
            <el-checkbox-group
              :min="1"
              v-model="selectedTag"
              class="flex flex-wrap"
            >
              <el-checkbox
                v-for="v in tabList"
                :label="v.couponLabelId"
                :key="v.couponLabelId"
              >
                {{ v.labelName }}
              </el-checkbox>
            </el-checkbox-group>
            <div
              class="error"
              v-show="
                tabList &&
                  tabList.length > 0 &&
                  selectedTag &&
                  selectedTag.length <= 0
              "
            >
              请选择分类
            </div>
          </div>
        </el-form-item>
        <div class="card-item flex">
          <div
            class="el-form-item__label"
            style="width: 140px;font-weight: 700;"
          >
            <span>标签：</span>
          </div>
          <div class="tag-wrapper">
            <el-tag
              :key="i"
              v-for="(lable, i) in smgLabelList"
              closable
              :disabled="strictEditMode"
              :disable-transitions="false"
              @close="handleClose(lable)"
              >{{ lable }}</el-tag
            >
            <el-input
              class="input-new-tag"
              v-if="inputVisible"
              v-model="labelValue"
              ref="saveTagInput"
              size="small"
              :disabled="strictEditMode"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            ></el-input>
            <el-button
              v-else
              class="button-new-tag"
              :disabled="strictEditMode"
              size="small"
              @click="showInput"
              >+ 新标签</el-button
            >
            <div class="title" v-show="labelList.length">常用标签</div>
            <div class="label-list">
              <div
                class="label-item"
                @click="insertLabel(v, i)"
                :disabel="strictEditMode"
                :class="{ active: activeLabel === i, disabled: strictEditMode }"
                v-for="(v, i) in labelList"
                :key="i"
              >
                {{ v }}
              </div>
            </div>
          </div>
        </div>
        <el-form-item label="自定义券标识：" prop="customName">
          <el-input
            size="small"
            @mousewheel.prevent.native
            clearable
            type="text"
            v-model.trim="ruleForm.customName"
            maxLength="8"
          ></el-input>
          <span class="form-tip"
            >（默认按类型展示通用券/线上券/门店券，自定义最长不超过8个字，设置后展示到优惠券左上角）</span
          >
        </el-form-item>
        <div class="card-item flex">
          <div class="flex">
            <div
              class="el-form-item__label"
              style="width: 140px;font-weight: 700;"
            >
              <span>备注：</span>
            </div>
            <div>
              <el-input
                size="small"
                clearable
                type="textarea"
                :rows="5"
                :cols="45"
                :maxlength="remarkLength"
                placeholder="请输入内容"
                v-model.trim="readme"
                :disabled="displayMode === 'detail'"
                show-word-limit
              ></el-input>
            </div>
          </div>
        </div>
        <el-form-item label="优惠券自定义背景">
          <el-upload
            :disabled="displayMode === 'detail'"
            class="upload flex"
            ref="upload"
            :limit="1"
            drag
            :data="{ fileDir: 'mall' }"
            :headers="{ 'X-Access-Token': $token }"
            :action="$uploadUrl"
            :on-remove="handleRemove"
            :onError="uploadError"
            :onSuccess="uploadSuccess"
            :beforeUpload="beforeAvatarUpload"
            :onProgress="uploading"
          >
            <div v-if="imgUrl" class="mr10 flex item-end priview">
              <img :src="imgUrl" alt="logo" />
              <!-- <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="handleRemove"
                      >删除</el-button
                    >
                  </div> -->
            </div>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将图片拖到此处，或
              <em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              <span class="mr">
                上传图标注意：
                <br />1.图片尺寸200*200 <br />2.图片大小100k内
                <br />3.图片格式：png、jpg、bmp
                <br />4.建议使用深色图标做背景，避免出现文字与背景重合情况
                <br />
              </span>
            </div>
          </el-upload>
        </el-form-item>
        <!-- 全显示 -->
        <div class="btn-wrapper text-center">
          <el-button
            size="small"
            type="primary"
            @click="save"
            :loading="isSaving"
            v-if="displayMode !== 'detail'"
            >{{ this.displayMode === "copy" ? "复制" : "保存" }}</el-button
          >
          <el-button size="small" @click="back">返回</el-button>
        </div>
      </el-form>
      <div id="dragContainer">
        <div class="preview-wrapper" id="dragbleElement">
          <div class="text-center">
            <el-button
              size="small"
              :type="isCollapse ? 'danger' : 'primary'"
              round
              @click="minimum"
            >
              <span class="hmicon icon-shouji"></span>
              <span>{{ isCollapse ? "点击展开" : "点击隐藏" }}</span>
              <span class="hmicon icon-youshuangjiantou arrow"></span>
            </el-button>
          </div>
          <transition name="fade">
            <div class="coupon-template" v-show="!isCollapse">
              <div class="phone-container">
                <div class="phone-header flex item-center">
                  <span class="hmicon icon-guanbi1 minimum"></span>
                  <span class="title">预览</span>
                  <span class="hmicon icon-xuanxiang setting"></span>
                </div>
                <div class="phone-body">
                  <div class="coupon flex" :class="couponCategory">
                    <div
                      class="coupon-amount flex flex-column flex-center item-center"
                      ref="couponAmount"
                      :style="{
                        backgroundImage:
                          imgUrl === '1' || !imgUrl ? '' : 'url(' + imgUrl + ')'
                      }"
                    >
                      <div class="amount flex">
                        <span class="currency" v-show="activeTab !== 1"
                          >￥</span
                        >
                        <span class="price">
                          {{ ruleForm.account || ruleForm.discount || 0 }}
                        </span>
                        <!-- <span class="logo" v-show="activeTab === 1">折</span> -->
                      </div>
                      <div class="limit">
                        满{{ ruleForm.levelMin || 0 }}使用
                      </div>
                      <div class="plus" v-show="target === 0">PLUS</div>
                    </div>
                    <div class="counpon-describe">
                      <div class="coupon-time flex item-center flex-between">
                        <div class="time flex-1">
                          <div class="coupon-name">
                            {{ ruleForm.name || "券名" }}
                          </div>
                          <div class="invalid-time">{{ invalidTime }}到期</div>
                          <div class="residue-time">
                            剩余时间：{{ residueTime }}
                          </div>
                        </div>
                        <div class="hollow-button">
                          使用
                        </div>
                      </div>
                      <div class="coupon-detail flex flex-between">
                        <span>详情</span>
                        <span class="hmicon icon-arrow-right"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import HmDateSelect from "@/components/HmCouponDateSelect";
import HmGoodsPicker from "@/components/HmGoodsPicker";
import { getCookie, getDateDiff, drag } from "../../utils/utils";
import moment from "moment";
import HmTransfer from "@/components/HmMicroShopTransfer";
import { getLoginUser } from "@/utils/auth";

// 暂时不保存运费券
export default {
  components: { HmDateSelect, HmGoodsPicker, HmTransfer },
  data() {
    const patternFunc = (rule, val, callback) => {
      if (val < 0) {
        return callback(new Error("请输入大于或等于0的数"));
      }
      callback();
    };
    const validateLimitNum = (rule, val, callback) => {
      if (val < this.initFetchLimitNum) {
        return callback(new Error("领取限制数量只能增加，不能减少"));
      }
      callback();
    };
    return {
      serviceCardTypeList: [
        {
          name: "禾苗月嫂电子券",
          value: "2020098000523"
        },
        {
          name: "禾苗产后恢复电子券",
          value: "2020098000522"
        },
        {
          name: "禾苗催乳电子券",
          value: "2020098000519"
        },
        {
          name: "禾苗造型馆电子券",
          value: "2020098000521"
        },
        {
          name: "禾苗胎毛制笔电子券",
          value: "2020098000520"
        },
        {
          name: "禾苗游泳抚触按摩电子券",
          value: "2020098000518"
        },
        {
          name: "禾苗推拿电子券",
          value: "2020098000517"
        },
        {
          name: "禾苗游泳电子券",
          value: "2020098000516"
        }
      ],
      remarkLength: "128",
      couponLevelList: [],
      smgLabelList: [],
      activeLabel: "",
      inputVisible: false,
      labelValue: "",
      isCollapse: true,
      disableSwitchTime: false,
      target: 1,
      ifSpec: false,
      sysTag: 0,
      displayMode: this.$route.query.type,
      ruleId: this.$route.query.ruleId,
      couponNameError: "",
      subTitle: "",
      brandId: "",
      name: "",
      activeTab: 0,
      couponTypeKeyword: "",
      couponType: "",
      couponCategory: "moneyOff",
      selectedTag: [],
      remark: "",
      account: "",
      levelMin: "",
      goodsName: "",
      isSaving: false,
      strictEditMode: false,
      selectedUseInTime: true,
      selectedUseInTimeDays: true,
      selectedRuleDate: true,
      selectedDay: true,
      isChecked: false,
      selectedWeek: false,
      selectedDaysList: false,
      selectedTimeList: true,
      leftRules: [],
      prefix: "",
      suffix: "",
      ruleDate: [], // 定时使用日期
      catIds: [],
      ruleStartDate: "",
      invalidTime: "1小时后",
      residueTime: "01:00:00",
      ruleEndDate: "",
      fetchLimitNum: 1, // 每人限领
      discount: "", // 折扣比率
      levelMax: "", // 折扣上限
      addon: false, // 是否允许叠加使用
      distance: "", // 距离
      readme: "",
      useRank: 0,
      catId: "",
      isEditMode: false,
      isxiaogan: false,
      loginInfoText: "",
      operateMemo: "",
      btnList: [
        { name: "满减券类", active: true, show: true, value: "moneyOff" }

        // { name: "抵用券", active: false, show: false, value: "discount" },
        // { name: "运费券类", active: false, show: false, value: "freight" }
      ],
      defaultProps: {
        children: "children",
        label: "name"
      },
      imgUrl: "",
      ruleForm: {
        name: "",
        couponLevel: "",
        levelMin: "",
        levelMax: "",
        discount: "",
        account: "",
        useNumLimit: "",
        useAmountLimit: "",
        prefix: "",
        suffix: "",
        fetchLimitNum: 1,
        couponModel: "",
        customName: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入券名", trigger: "blur" },
          {
            min: 1,
            max: 15,
            message: "券名长度需要 1 到 15 个字符",
            trigger: "blur"
          }
        ],
        couponLevel: {
          required: true,
          message: "请选择优惠券层级",
          trigger: "blur"
        },
        couponModel: {
          required: true,
          message: "选择服务卡类型",
          trigger: "blur"
        },
        levelMin: [
          { required: true, message: "请输入使用门槛", trigger: "blur" },
          { validator: patternFunc, trigger: "blur" }
        ],
        levelMax: [
          { required: true, message: "请输入折扣上限", trigger: "blur" },
          {
            pattern: /^[1-9]\d*$/,
            message: "请输入大于0的正整数",
            trigger: "blur"
          }
        ],
        account: [
          { required: true, message: "请输人减免金额", trigger: "blur" },
          { validator: patternFunc, trigger: "blur" }
        ],
        discount: [
          { required: true, message: "请输人折扣数", trigger: "blur" },
          {
            pattern: /^(?!0(\.0{1,2})?$)(\d(\.\d{1,2})?|9.99)$/,
            message:
              "请输入大于或等于0.01且小于或等于9.99的数,小数最多保留两位",
            trigger: "blur"
          }
        ],
        fetchLimitNum: [
          { required: true, message: "请输人领取限制", trigger: "blur" },
          {
            pattern: /^[1-9]\d*$/,
            message: "请输入大于0的正整数",
            trigger: "blur"
          },
          {
            validator: validateLimitNum
          }
        ],
        prefix: [
          {
            min: 1,
            max: 10,
            message: "券号应小于等于10个字符",
            trigger: "blur"
          },
          {
            pattern: /^[0-9a-zA-Z]+$/,
            message: "请输入字母或数字",
            trigger: "blur"
          }
        ],
        suffix: [
          {
            min: 1,
            max: 10,
            message: "券号应小于等于10个字符",
            trigger: "blur"
          },
          {
            pattern: /^[0-9a-zA-Z]+$/,
            message: "请输入字母或数字",
            trigger: "blur"
          }
        ]
      },
      iskunming: false,
      initFetchLimitNum: 1
    };
  },
  computed: mapState({
    isValidRule: state => state.rules.isValidRule,
    storeCouponRule: state => state.rules.storeCouponRule,
    setRulesCode: state => state.rules.setRulesCode,
    specifiedRule: state => state.rules.specifiedRule,
    editNewRulesCode: state => state.rules.editNewRulesCode,
    writeCode: state => state.rules.writeCode,
    writeMsg: state => state.rules.writeMsg,
    storeConfig: state => state.rules.storeConfig,
    setRulesResult: state => state.rules.setRulesResult,
    tabList: state => state.rules.tabList,
    labelList: state => state.rules.labelList,
    salesChannels: state => {
      const list = state.goodsLib.salesChannels;

      list.forEach(v => {
        if (v.platformName === "微店") {
          v.useRank = 1;
        }
      });
      return list;
    }
  }),
  watch: {
    isValidRule(val) {
      if (val > 0) {
        // 不可用
        this.couponNameError = "已有该券名,请重新设置";
      }
      this.$store.commit("checkRuleValid", "");
    },
    useRank() {
      const ref = ["serveiceGoods"];
      ref.forEach(v => {
        if (this.$refs[v]) {
          this.$refs[v].pickedList = [];
          this.$refs[v].rightData = [];
        }
      });
      // if (val === 2 && (this.activeTab === 2 || this.activeTab === 1)) {
      //   this.activeTab = 0;
      // }
      this.couponCategory =
        this.activeTab === 0
          ? "moneyOff"
          : this.activeTab === 1
          ? "discount"
          : "freight";
      this.catId = "";
      this.brandId = "";
      this.goodsName = "";
      this.catIds = [];
    },
    sysTag(val) {
      if (val === 1) {
        this.useRank = 0;
      }
      this.activeTab = 0;
    },
    couponType(val) {
      this.name = val.name;
    },
    setRulesCode(val) {
      if (val === "0") {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.$router.back(-1);
      }
      this.isSaving = false;
      this.$store.state.rules.setRulesCode = "";
    },
    editNewRulesCode(val) {
      if (val === "0") {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.$router.back(-1);
      }
      this.isSaving = false;
      this.$store.state.rules.editNewRulesCode = "";
    },
    writeCode(val) {
      if (val === "0") {
        this.$message({
          message: "操作成功," + this.writeMsg,
          type: "success"
        });
        this.$router.back(-1);
      }
      this.isSaving = false;
      this.$store.state.rules.writeCode = "";
    },
    specifiedRule(val) {
      const { couponRule, goodsRuleList, ruleTime, label } = val;
      this.smgLabelList = couponRule.smgLabelList || [];
      for (let key in couponRule) {
        if (this.hasOwnProperty(key)) {
          this[key] = couponRule[key];
        }
        if (this.ruleForm.hasOwnProperty(key)) {
          this.ruleForm[key] = couponRule[key];
        }
      }
      this.initFetchLimitNum = couponRule.fetchLimitNum || 1
      this.ruleForm.couponLevel = this.ruleForm.couponLevel + "";
      // 判断是否plus会员
      this.target = couponRule ? couponRule.isPlus : 1;
      // --------------------------------------
      // 表单验证
      this.ruleForm.name = couponRule ? couponRule.name : "";
      this.addon = couponRule && couponRule.addon === 1;
      this.ifSpec = this.ifSpec === 1;
      // --------------------------------------
      this.name = couponRule ? couponRule.name : "";
      this.activeTab = couponRule ? couponRule.type : 0;

      this.couponCategory =
        this.activeTab === 0
          ? "moneyOff"
          : this.activeTab === 1
          ? "discount"
          : "freight";
      label.forEach(v => {
        this.selectedTag.push(v.couponLabelId);
      });
      console.log("goodsRuleList: ", goodsRuleList);
      // const goodsList = [];
      goodsRuleList.forEach(v => {
        v.attrValue = v.goodsInfo || v.catName || v.brandName || v.attrName;
        v.attrId =
          v.goodsId || v.cat || v.brandId || v.attr || v.goodsSn || v.barcode;
        v.whitelistState = v.useable === 1 ? "white" : "black";
        if(this.isEditMode){
          v.checked = false;
          v.disabled = true;
        }else{
          v.checked = true;
          v.disabled = false;
        }
      });
      this.$refs.ruleTransfer.rightData = goodsRuleList;
      this.$refs.ruleTransfer.rightChecked = goodsRuleList;
      // setTimeout(() => {
      //   if (this.sysTag === 1) {
      //     this.$refs.serveiceGoods.pickedList = goodsList;
      //   }
      // }, 0);
      this.$refs.hmDateSelect.ruleTimeStrategyType =
        !couponRule.ruleTimeStrategyType ||
        couponRule.ruleTimeStrategyType === 4
          ? 0
          : couponRule.ruleTimeStrategyType;
      this.$refs.hmDateSelect.timeList = ruleTime;
      if (couponRule.ruleTimeStrategyType === 4) {
        const time = [
          new Date(
            couponRule.ruleStartDate +
              " " +
              couponRule.ruleStartTime.split(",")[0]
          ),
          new Date(
            couponRule.ruleEndDate + " " + couponRule.ruleEndTime.split(",")[0]
          )
        ];
        this.$refs.hmDateSelect.ruleDateAndTime = time;
      }
      if (couponRule.ruleStartDate !== "") {
        this.$refs.hmDateSelect.ruleDate = [
          moment(couponRule.ruleStartDate).format("YYYY-MM-DD"),
          moment(couponRule.ruleEndDate).format("YYYY-MM-DD")
        ];
      } else {
        this.$refs.hmDateSelect.ruleDate = [];
      }
      this.$refs.hmDateSelect.day = couponRule.perday;
      this.$refs.hmDateSelect.week = couponRule.perweek
        ? couponRule.perweek.split(",")
        : [];
      this.$refs.hmDateSelect.daysList = couponRule.permonth
        ? couponRule.permonth.split(",").map(v => parseInt(v, 10))
        : [];
      console.log("couponRule.useImmediately: ", couponRule.useImmediately);
      setTimeout(() => {
        if (couponRule && couponRule.useImmediately === 0) {
          if (couponRule.ruleTimeStrategyType === 4) {
            this.$refs.hmDateSelect.useImmediately = 2;
          } else {
            this.$refs.hmDateSelect.useImmediately = 0;
          }
        } else if (couponRule && couponRule.useImmediately !== 0) {
          if (couponRule.immediatelyType === "day") {
            this.$refs.hmDateSelect.useImmediately = 3;
          } else {
            this.$refs.hmDateSelect.useImmediately = 1;
          }
        }
      }, 0);
      this.$refs.hmDateSelect.immediatelyEffective =
        couponRule.immediatelyEffective;
      this.$refs.hmDateSelect.immediatelyEffectiveDays =
        couponRule.immediatelyEffectiveDays;

      // setTimeout(() => {
      //   this.$refs.ruleTransfer.isVouchers =
      //     this.activeTab == "1" ? true : false;
      // }, 2000);
    }
  },
  created() {
    this.allowAddNewGoodsToErpCouponRule().then(res=>{
      this.init();
    });
  },
  mounted() {
    console.log("mounted测试");
    if (this.displayMode === "detail") {
      this.strictEditMode = true;
    }
    const dragbleElement = document.getElementById("dragbleElement");
    const dragContainer = document.getElementById("dragContainer");
    drag.startDrag(dragContainer, dragbleElement);
    this.queryCouponLevelList();
  },
  methods: {
    init(){
      console.log("created测试1");
      let username = "";
      let realname = "";
      if(getLoginUser().username){
        username = "账号:" + getLoginUser().username;
      }else{
        username = "";
      }
      if(getLoginUser().realname){
        realname = ",用户:" + getLoginUser().realname;
      }else{
        realname = "";
      }
      this.loginInfoText = username + realname;
      console.log("this.loginInfoText:",this.loginInfoText);
        this.iskunming =
          getLoginUser().storeCode === "42010216070190" ||
          getLoginUser().storeCode === "53010017032439";
        const link = getCookie({ key: "link" });
        this.$store.dispatch("querySalesChannels");
        this.subTitle = link ? link[link.length - 1].name : "添加优惠券";
        // this.$store.dispatch('queryStoreCouponRule', {
        //   typeName: '',
        // })
        if (
          this.displayMode === "edit" ||
          this.displayMode === "copy" ||
          this.displayMode === "detail"
        ) {
          this.$store.dispatch("querySpecifiedRule", {
            ruleId: this.ruleId
          });
        }
        console.log("this.isxiaogan",this.isxiaogan);
        //
        if(this.displayMode === "edit" && this.isxiaogan){
          this.isEditMode = true;
        }
        /**
         * @couponStatus 0 '未开始' 1 '进行中'
         * @couponType 1 '线上' 2： '门店'
         */
        const { couponStatus, couponType } = this.$route.query;
        if (
          this.displayMode === "edit" &&
          (Number(couponStatus) === 1 || Number(couponStatus) === 0) &&
          Number(couponType) === 2
        ) {
          this.strictEditMode = true;
        }
        if (this.displayMode === "edit") {
          this.strictEditMode = true;
        }

        if (Number(couponStatus) === 1 && Number(couponType) === 1) {
          this.disableSwitchTime = true;
        }
        this.$store.dispatch("queryStoreConfig");
        this.$store.dispatch("querySmgLabel");
        this.$store.dispatch("queryTab", {
          labelName: "",
          pageSize: 9999999,
          type: "back"
        });
        console.log("created测试2");
        this.getParamValueAllowNull();
    },
    async queryCouponLevelList() {
      let params = {
        dictCode: "coupon_level"
      };
      const { result } = await this.$store.dispatch(
        "queryCouponLevelList",
        params
      );
      if (result) {
        const { sysDictItem } = result;

        this.couponLevelList = sysDictItem;
      }
    },
    handleClose(label) {
      if (!this.strictEditMode) {
        this.smgLabelList.splice(this.smgLabelList.indexOf(label), 1);
      }
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let labelValue = this.labelValue;
      if (!this.smgLabelList) {
        this.smgLabelList = [];
      }
      if (labelValue) {
        this.smgLabelList.push(labelValue);
      }
      this.smgLabelList = [...new Set(this.smgLabelList)];
      this.inputVisible = false;
      this.labelValue = "";
    },
    insertLabel(v, i) {
      if (!this.strictEditMode) {
        if (this.activeLabel !== i) {
          this.smgLabelList.push(v);
          this.smgLabelList = [...new Set(this.smgLabelList)];
        }
        this.activeLabel = i;
      }
    },
    getStorcouponRule(e) {
      this.storeCouponRule.forEach(v => {
        if (e === v.id) {
          this.name = v.name;
        }
      });
    },
    useNumLimitChange() {
      if (this.ruleForm.useNumLimit == "" || this.ruleForm.account == "") {
        this.ruleForm.useAmountLimit = "";
      } else {
        this.ruleForm.useAmountLimit =
          this.ruleForm.useNumLimit * this.ruleForm.account;
      }
    },
    filterGt0OrFixed(prop) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d]/g, "");
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "");
    },
    filterGt0OrFixed0(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "")
        .replace("-", "");

      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    filterGt0OrFixed2(prop) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数

      if (this.ruleForm[prop].indexOf(".") === 0) {
        this.ruleForm[prop] = "";
      }
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    switchTab(index) {
      this.activeTab = index;
      this.couponCategory =
        index === 0 ? "moneyOff" : index === 1 ? "discount" : "freight";
    },
    queryStoreCoupon() {
      this.$store.dispatch("queryStoreCouponRule", {
        typeName: this.couponTypeKeyword
      });
    },
    async getParamValueAllowNull() {
      console.log("getParamValueAllowNull");
      const { code ,result } = await this.$store.dispatch("getParamValueAllowNull", {
        paramCode: "couponrule_remark_length"
      })
      if (code === "0") {
        if(result.paramValue)
        {
          this.remarkLength = result.paramValue;
        }else{
          this.remarkLength = "128";
        }
        console.log("this.remarkLength",this.remarkLength)
      }
    },
    //是否允许编辑优惠券商品
    async allowAddNewGoodsToErpCouponRule() {
      const { code ,result } = await this.$store.dispatch("getParamValueAllowNull", {
        paramCode: "allowAddNewGoodsToCouponRule"
      })
      if (code === "0") {
        if(result.paramValue==='yes'){
          this.isxiaogan = true;
        }
      }
    },
    back() {
      this.$router.back();
    },
    handleCheckChange() {
      this.isChecked = this.$refs.tree.getCheckedNodes().length > 0;
    },
    activeTabChange() {
      this.ruleForm.levelMin = "";
      if (this.$refs.ruleTransfer) {
        this.$refs.ruleTransfer.leftData = [];
        this.$refs.ruleTransfer.leftChecked = [];
        this.$refs.ruleTransfer.rightData = [];
        this.$refs.ruleTransfer.rightChecked = [];
      }
    },
    sendSaveRequest() {
      console.log("this.activeTab: ", this.activeTab);
      let str = "";
      let goodsListParams,addGoodsListParams;
      if(this.isEditMode){
          goodsListParams = this.$refs.ruleTransfer.rightChecked.filter(v => v.disabled === true) || [];
          addGoodsListParams =  this.$refs.ruleTransfer.rightChecked.filter(v => v.disabled === false) || [];
          addGoodsListParams.forEach(v=>{
            let attrTypetemp;
            let strtemp;
            let attrIdtemp;
            // attrId
            if(v.attrType==='brand'){
               attrTypetemp='品牌名称';
               attrIdtemp = ""
            }else if(v.attrType==='category'){
               attrTypetemp='品类名称';
               attrIdtemp = ""
            }else if(v.attrType==='goods'){
               attrTypetemp='商品名称';
               attrIdtemp = ",货号:" + v.attrValue
            }
            strtemp = ",新增" + attrTypetemp + ":" + v.attrValue + attrIdtemp;
            str += strtemp;
          })
          let customName;
          if(this.ruleForm.customName){
            customName = ",自定义标签:"+this.ruleForm.customName
          }
          this.operateMemo = this.loginInfoText + str + customName;
          console.log('this.operateMemo:'+ this.operateMemo);
      } else {
        if (this.$refs && this.$refs.ruleTransfer) {
          goodsListParams = this.$refs.ruleTransfer.rightChecked;
        }
          addGoodsListParams = [];
      }
      if (this.activeTab == "0") {
        // 不同券传的参数不同
        this.rules.levelMin[0].required =
          this.activeTab === 0 || this.activeTab === 1 || this.activeTab === 5;
        this.rules.levelMax[0].required = this.activeTab === 1;
        this.rules.discount[0].required = this.activeTab === 1;
        this.rules.account[0].required = this.activeTab !== 1;
        // 获取传入商品
        const hmDateSelect = this.$refs.hmDateSelect;
        let goodsOfflineList = [];
        if (this.sysTag === 1) {
          goodsOfflineList = this.$refs.serveiceGoods.pickedList;
        }
        // 获取日期
        const {
          ruleTimeStrategyType,
          day,
          week,
          daysList,
          timeList,
          useImmediately,
          immediatelyEffective,
          immediatelyEffectiveDays,
          ruleDate,
          isRequiredFormat,
          timeType,
          ruleDateAndTime
        } = hmDateSelect;

        let immediatelyType = "";
        if (useImmediately === 3) {
          immediatelyType = "day";
        } else if (useImmediately === 1) {
          immediatelyType = "hour";
        }

        let ruleStartDate = "";
        let ruleEndDate = "";
        let list = [];
        if (useImmediately === 0) {
          ruleStartDate = ruleDate && ruleDate.length > 0 && ruleDate[0];
          ruleEndDate = ruleDate && ruleDate.length > 0 && ruleDate[1];
          // 是否选择中使用日期
          this.selectedRuleDate = ruleDate !== null;
          // 是否选择使用日月周
          this.selectedDay = day !== "" && day > 0;
          this.selectedWeek = week.length > 0;
          this.selectedDaysList = daysList.length > 0;
          // 是否选择中使用时间
          this.selectedTimeList = timeList.length > 0;
          list = timeList;
        } else if (useImmediately === 1 || useImmediately === 3) {
          // 是否选中时间
          this.selectedUseInTime = immediatelyEffective !== "";
          this.selectedUseInTimeDays = immediatelyEffectiveDays !== "";
        } else if (
          useImmediately === 2 &&
          ruleDateAndTime &&
          ruleDateAndTime.length > 0
        ) {
          ruleStartDate = moment(ruleDateAndTime[0]).format("YYYY-MM-DD");
          ruleEndDate = moment(ruleDateAndTime[1]).format("YYYY-MM-DD");
          list = [
            {
              start: moment(ruleDateAndTime[0]).format("HH:mm:ss"),
              end: moment(ruleDateAndTime[1]).format("HH:mm:ss")
            }
          ];
        }
        for (let i = 0; i < daysList.length; i++) {
          daysList[i] = daysList[i] < 10 ? `0${daysList[i]}` : daysList[i];
        }
        const dateSelectType =
          useImmediately === 0
            ? ruleTimeStrategyType
            : useImmediately === 2
            ? 4
            : "";
        // 获取是否plus会员
        // 设置传输参数        
        goodsListParams.forEach(v => {
          if (v.attrType == "barcode") {
            v.attrType = "goods";
          }
        })
        console.log("goodsListParams:",goodsListParams);
        let params = {
          operateMemo: this.operateMemo,
          immediatelyType,
          goodsList: goodsListParams,
          addGoodsList: addGoodsListParams,
          goodsOfflineList,
          smgLabelList: this.smgLabelList,
          sysTag: this.sysTag,
          isPlus: this.target,
          name: this.ruleForm.name,
          type: this.activeTab,
          useNumLimit: this.ruleForm.useNumLimit,
          useAmountLimit: this.ruleForm.useAmountLimit,
          levelMin: this.ruleForm.levelMin,
          account: this.ruleForm.account,
          prefix: this.ruleForm.prefix,
          suffix: this.ruleForm.suffix,
          couponLevel: this.ruleForm.couponLevel,
          levelMax: this.activeTab === 1 ? this.ruleForm.levelMax : "",
          ruleStartDate,
          ruleEndDate,
          fetchLimitNum: this.ruleForm.fetchLimitNum,
          useRank: this.useRank,
          discount: this.activeTab === 1 ? this.ruleForm.discount : "",
          ruleTimeStrategyType: dateSelectType,
          day: useImmediately === 0 ? day : "",
          week: useImmediately === 0 ? week.toString() : "",
          daysList: useImmediately === 0 ? daysList.toString() : "",
          perday: useImmediately === 0 ? day : "",
          perweek: useImmediately === 0 ? week.toString() : "",
          permonth: useImmediately === 0 ? daysList.toString() : "",
          useImmediately: useImmediately === 1 || useImmediately === 3 ? 1 : 0,
          imgUrl: this.imgUrl,
          immediatelyEffective:
            useImmediately === 1 || useImmediately === 3
              ? timeType === 0
                ? immediatelyEffective
                : immediatelyEffective
              : "",
          immediatelyEffectiveDays:
            useImmediately === 1 || useImmediately === 3
              ? timeType === 0
                ? immediatelyEffectiveDays
                : immediatelyEffectiveDays
              : "",
          list,
          readme: this.readme,
          icon: "",
          addon: this.addon ? 1 : 0,
          distance: this.distance,
          labelId: this.selectedTag,
          ifSpec: this.ifSpec ? 1 : 0, // 过滤特价商品 1 不过滤 0
          customName: this.ruleForm.customName,
        };
        this.$refs.ruleForm.validate(valid => {
          // 表单验证
          if (valid && this.couponNameError === "") {
            if (
              (this.tabList.length > 0 && this.selectedTag.length > 0) ||
              this.tabList.length <= 0
            ) {
              if (
                ((useImmediately === 1 || useImmediately === 3) &&
                  this.selectedUseInTime &&
                  this.selectedUseInTimeDays &&
                  isRequiredFormat) ||
                (useImmediately === 0 &&
                  this.selectedRuleDate &&
                  this.selectedTimeList &&
                  ((ruleTimeStrategyType === 0 && this.selectedDay) ||
                    (ruleTimeStrategyType === 1 && this.selectedWeek) ||
                    (ruleTimeStrategyType === 2 && this.selectedDaysList))) ||
                (useImmediately === 2 &&
                  ruleStartDate &&
                  ruleEndDate &&
                  list.length > 0)
              ) {
                // 即领即用;
                if (this.displayMode === "edit") {
                  params.ruleId = this.$route.query.ruleId;
                  this.$store.dispatch("editNewRules", params);
                } else if (
                  this.displayMode === "add" ||
                  this.displayMode === "copy"
                ) {
                  this.$store.dispatch("setRules", params);
                }
                this.isSaving = true;
              }
            }
          } else {
            return false;
          }
        });
      } else if (this.activeTab == "1") {
        if (this.$refs.ruleTransfer.rightChecked.length) {
          // 不同券传的参数不同
          this.rules.levelMin[0].required =
            this.activeTab === 0 ||
            this.activeTab === 1 ||
            this.activeTab === 5;
          this.rules.levelMax[0].required = this.activeTab === 1;
          this.rules.discount[0].required = this.activeTab === 1;
          this.rules.account[0].required = this.activeTab !== 1;
          // 获取传入商品
          const hmDateSelect = this.$refs.hmDateSelect;
          let goodsOfflineList = [];
          if (this.sysTag === 1) {
            goodsOfflineList = this.$refs.serveiceGoods.pickedList;
          }
          // 获取日期
          const {
            ruleTimeStrategyType,
            day,
            week,
            daysList,
            timeList,
            useImmediately,
            immediatelyEffective,
            immediatelyEffectiveDays,
            ruleDate,
            isRequiredFormat,
            timeType,
            ruleDateAndTime
          } = hmDateSelect;

          let immediatelyType = "";
          if (useImmediately === 3) {
            immediatelyType = "day";
          } else if (useImmediately === 1) {
            immediatelyType = "hour";
          }

          let ruleStartDate = "";
          let ruleEndDate = "";
          let list = [];
          if (useImmediately === 0) {
            ruleStartDate = ruleDate && ruleDate.length > 0 && ruleDate[0];
            ruleEndDate = ruleDate && ruleDate.length > 0 && ruleDate[1];
            // 是否选择中使用日期
            this.selectedRuleDate = ruleDate !== null;
            // 是否选择使用日月周
            this.selectedDay = day !== "" && day > 0;
            this.selectedWeek = week.length > 0;
            this.selectedDaysList = daysList.length > 0;
            // 是否选择中使用时间
            this.selectedTimeList = timeList.length > 0;
            list = timeList;
          } else if (useImmediately === 1 || useImmediately === 3) {
            // 是否选中时间
            this.selectedUseInTime = immediatelyEffective !== "";
            this.selectedUseInTimeDays = immediatelyEffectiveDays !== "";
          } else if (
            useImmediately === 2 &&
            ruleDateAndTime &&
            ruleDateAndTime.length > 0
          ) {
            ruleStartDate = moment(ruleDateAndTime[0]).format("YYYY-MM-DD");
            ruleEndDate = moment(ruleDateAndTime[1]).format("YYYY-MM-DD");
            list = [
              {
                start: moment(ruleDateAndTime[0]).format("HH:mm:ss"),
                end: moment(ruleDateAndTime[1]).format("HH:mm:ss")
              }
            ];
          }
          for (let i = 0; i < daysList.length; i++) {
            daysList[i] = daysList[i] < 10 ? `0${daysList[i]}` : daysList[i];
          }
          const dateSelectType =
            useImmediately === 0
              ? ruleTimeStrategyType
              : useImmediately === 2
              ? 4
              : "";
          // 获取是否plus会员
          // 设置传输参数
          goodsListParams.forEach(v => {
            if (v.attrType == "barcode") {
              v.attrType = "goods";
            }
          })
          console.log("goodsListParams:",goodsListParams);
          let params = {
            operateMemo: this.operateMemo,
            immediatelyType,
            goodsList: goodsListParams,
            addGoodsList: addGoodsListParams,
            goodsOfflineList,
            smgLabelList: this.smgLabelList,
            sysTag: this.sysTag,
            isPlus: this.target,
            name: this.ruleForm.name,
            type: this.activeTab,
            levelMin: this.ruleForm.levelMin,
            account: this.ruleForm.account,
            prefix: this.ruleForm.prefix,
            suffix: this.ruleForm.suffix,
            levelMax: this.activeTab === 1 ? this.ruleForm.levelMax : "",
            ruleStartDate,
            ruleEndDate,
            fetchLimitNum: this.ruleForm.fetchLimitNum,
            useRank: this.useRank,
            discount: this.activeTab === 1 ? this.ruleForm.discount : "",
            ruleTimeStrategyType: dateSelectType,
            day: useImmediately === 0 ? day : "",
            week: useImmediately === 0 ? week.toString() : "",
            daysList: useImmediately === 0 ? daysList.toString() : "",
            perday: useImmediately === 0 ? day : "",
            perweek: useImmediately === 0 ? week.toString() : "",
            permonth: useImmediately === 0 ? daysList.toString() : "",
            useImmediately:
              useImmediately === 1 || useImmediately === 3 ? 1 : 0,
            imgUrl: this.imgUrl,
            immediatelyEffective:
              useImmediately === 1 || useImmediately === 3
                ? timeType === 0
                  ? immediatelyEffective
                  : immediatelyEffective
                : "",
            immediatelyEffectiveDays:
              useImmediately === 1 || useImmediately === 3
                ? timeType === 0
                  ? immediatelyEffectiveDays
                  : immediatelyEffectiveDays
                : "",
            list,
            readme: this.readme,
            icon: "",
            addon: this.addon ? 1 : 0,
            distance: this.distance,
            labelId: this.selectedTag,
            ifSpec: this.ifSpec ? 1 : 0, // 过滤特价商品 1 不过滤 0
            customName: this.ruleForm.customName,
          };
          this.$refs.ruleForm.validate(valid => {
            // 表单验证
            if (valid && this.couponNameError === "") {
              if (
                (this.tabList.length > 0 && this.selectedTag.length > 0) ||
                this.tabList.length <= 0
              ) {
                if (
                  ((useImmediately === 1 || useImmediately === 3) &&
                    this.selectedUseInTime &&
                    this.selectedUseInTimeDays &&
                    isRequiredFormat) ||
                  (useImmediately === 0 &&
                    this.selectedRuleDate &&
                    this.selectedTimeList &&
                    ((ruleTimeStrategyType === 0 && this.selectedDay) ||
                      (ruleTimeStrategyType === 1 && this.selectedWeek) ||
                      (ruleTimeStrategyType === 2 && this.selectedDaysList))) ||
                  (useImmediately === 2 &&
                    ruleStartDate &&
                    ruleEndDate &&
                    list.length > 0)
                ) {
                  // 即领即用
                  if (this.displayMode === "edit") {
                    params.ruleId = this.$route.query.ruleId;
                    this.$store.dispatch("editNewRules", params);
                  } else if (
                    this.displayMode === "add" ||
                    this.displayMode === "copy"
                  ) {
                    this.$store.dispatch("setRules", params);
                  }
                  this.isSaving = true;
                }
              }
            } else {
              return false;
            }
          });
        } else {
          this.$message({
            message: "请选择兑换券商品！",
            type: "warning"
          });
        }
      } else if (this.activeTab == "2") {
        // 不同券传的参数不同
        this.rules.levelMin[0].required =
          this.activeTab === 0 || this.activeTab === 1 || this.activeTab === 5;
        this.rules.levelMax[0].required = this.activeTab === 1;
        this.rules.discount[0].required = this.activeTab === 1;
        this.rules.account[0].required = this.activeTab !== 1;
        // 获取传入商品
        const hmDateSelect = this.$refs.hmDateSelect;
        // let goodsOfflineList = [];
        // if (this.sysTag === 1) {
        //   goodsOfflineList = this.$refs.serveiceGoods.pickedList;
        // }

        // 获取日期
        const {
          ruleTimeStrategyType,
          day,
          week,
          daysList,
          timeList,
          useImmediately,
          immediatelyEffective,
          immediatelyEffectiveDays,
          ruleDate,
          isRequiredFormat,
          timeType,
          ruleDateAndTime
        } = hmDateSelect;

        let immediatelyType = "";
        if (useImmediately === 3) {
          immediatelyType = "day";
        } else if (useImmediately === 1) {
          immediatelyType = "hour";
        }

        let ruleStartDate = "";
        let ruleEndDate = "";
        let list = [];
        if (useImmediately === 0) {
          ruleStartDate = ruleDate && ruleDate.length > 0 && ruleDate[0];
          ruleEndDate = ruleDate && ruleDate.length > 0 && ruleDate[1];
          // 是否选择中使用日期
          this.selectedRuleDate = ruleDate !== null;
          // 是否选择使用日月周
          this.selectedDay = day !== "" && day > 0;
          this.selectedWeek = week.length > 0;
          this.selectedDaysList = daysList.length > 0;
          // 是否选择中使用时间
          this.selectedTimeList = timeList.length > 0;
          list = timeList;
        } else if (useImmediately === 1 || useImmediately === 3) {
          // 是否选中时间
          this.selectedUseInTime = immediatelyEffective !== "";
          this.selectedUseInTimeDays = immediatelyEffectiveDays !== "";
        } else if (
          useImmediately === 2 &&
          ruleDateAndTime &&
          ruleDateAndTime.length > 0
        ) {
          ruleStartDate = moment(ruleDateAndTime[0]).format("YYYY-MM-DD");
          ruleEndDate = moment(ruleDateAndTime[1]).format("YYYY-MM-DD");
          list = [
            {
              start: moment(ruleDateAndTime[0]).format("HH:mm:ss"),
              end: moment(ruleDateAndTime[1]).format("HH:mm:ss")
            }
          ];
        }
        for (let i = 0; i < daysList.length; i++) {
          daysList[i] = daysList[i] < 10 ? `0${daysList[i]}` : daysList[i];
        }
        const dateSelectType =
          useImmediately === 0
            ? ruleTimeStrategyType
            : useImmediately === 2
            ? 4
            : "";
        let params = {
          operateMemo: this.operateMemo,
          immediatelyType,
          smgLabelList: this.smgLabelList,
          sysTag: this.sysTag,
          isPlus: this.target,
          name: this.ruleForm.name,
          type: this.activeTab,
          levelMin: 0,
          account: this.ruleForm.account,
          prefix: this.ruleForm.prefix,
          suffix: this.ruleForm.suffix,
          levelMax: this.activeTab === 1 ? this.ruleForm.levelMax : "",
          ruleStartDate,
          ruleEndDate,
          fetchLimitNum: this.ruleForm.fetchLimitNum,
          useRank: this.useRank,
          discount: this.activeTab === 1 ? this.ruleForm.discount : "",
          ruleTimeStrategyType: dateSelectType,
          day: useImmediately === 0 ? day : "",
          week: useImmediately === 0 ? week.toString() : "",
          daysList: useImmediately === 0 ? daysList.toString() : "",
          perday: useImmediately === 0 ? day : "",
          perweek: useImmediately === 0 ? week.toString() : "",
          permonth: useImmediately === 0 ? daysList.toString() : "",
          useImmediately: useImmediately === 1 || useImmediately === 3 ? 1 : 0,
          imgUrl: this.imgUrl,
          immediatelyEffective:
            useImmediately === 1 || useImmediately === 3
              ? timeType === 0
                ? immediatelyEffective
                : immediatelyEffective
              : "",
          immediatelyEffectiveDays:
            useImmediately === 1 || useImmediately === 3
              ? timeType === 0
                ? immediatelyEffectiveDays
                : immediatelyEffectiveDays
              : "",
          list,
          readme: this.readme,
          icon: "",
          addon: this.addon ? 1 : 0,
          distance: this.distance,
          labelId: this.selectedTag,
          ifSpec: this.ifSpec ? 1 : 0, // 过滤特价商品 1 不过滤 0
          customName: this.ruleForm.customName,
        };
        this.$refs.ruleForm.validate(valid => {
          // 表单验证
          if (valid && this.couponNameError === "") {
            if (
              (this.tabList.length > 0 && this.selectedTag.length > 0) ||
              this.tabList.length <= 0
            ) {
              if (
                ((useImmediately === 1 || useImmediately === 3) &&
                  this.selectedUseInTime &&
                  this.selectedUseInTimeDays &&
                  isRequiredFormat) ||
                (useImmediately === 0 &&
                  this.selectedRuleDate &&
                  this.selectedTimeList &&
                  ((ruleTimeStrategyType === 0 && this.selectedDay) ||
                    (ruleTimeStrategyType === 1 && this.selectedWeek) ||
                    (ruleTimeStrategyType === 2 && this.selectedDaysList))) ||
                (useImmediately === 2 &&
                  ruleStartDate &&
                  ruleEndDate &&
                  list.length > 0)
              ) {
                // 即领即用
                if (this.displayMode === "edit") {
                  params.ruleId = this.$route.query.ruleId;
                  this.$store.dispatch("editNewRules", params);
                } else if (
                  this.displayMode === "add" ||
                  this.displayMode === "copy"
                ) {
                  this.$store.dispatch("setRules", params);
                }
                this.isSaving = true;
              }
            }
          } else {
            return false;
          }
        });
      } else if (this.activeTab == "3") {
        // 不同券传的参数不同
        this.rules.levelMin[0].required =
          this.activeTab === 0 || this.activeTab === 1;
        this.rules.levelMax[0].required = this.activeTab === 1;
        this.rules.discount[0].required = this.activeTab === 1;
        this.rules.account[0].required = this.activeTab !== 1;
        // 获取传入商品
        const hmDateSelect = this.$refs.hmDateSelect;
        // let goodsOfflineList = [];
        // if (this.sysTag === 1) {
        //   goodsOfflineList = this.$refs.serveiceGoods.pickedList;
        // }

        // 获取日期
        const {
          ruleTimeStrategyType,
          day,
          week,
          daysList,
          timeList,
          useImmediately,
          immediatelyEffective,
          immediatelyEffectiveDays,
          ruleDate,
          isRequiredFormat,
          timeType,
          ruleDateAndTime
        } = hmDateSelect;

        let immediatelyType = "";
        if (useImmediately === 3) {
          immediatelyType = "day";
        } else if (useImmediately === 1) {
          immediatelyType = "hour";
        }

        let ruleStartDate = "";
        let ruleEndDate = "";
        let list = [];
        if (useImmediately === 0) {
          ruleStartDate = ruleDate && ruleDate.length > 0 && ruleDate[0];
          ruleEndDate = ruleDate && ruleDate.length > 0 && ruleDate[1];
          // 是否选择中使用日期
          this.selectedRuleDate = ruleDate !== null;
          // 是否选择使用日月周
          this.selectedDay = day !== "" && day > 0;
          this.selectedWeek = week.length > 0;
          this.selectedDaysList = daysList.length > 0;
          // 是否选择中使用时间
          this.selectedTimeList = timeList.length > 0;
          list = timeList;
        } else if (useImmediately === 1 || useImmediately === 3) {
          // 是否选中时间
          this.selectedUseInTime = immediatelyEffective !== "";
          this.selectedUseInTimeDays = immediatelyEffectiveDays !== "";
        } else if (
          useImmediately === 2 &&
          ruleDateAndTime &&
          ruleDateAndTime.length > 0
        ) {
          ruleStartDate = moment(ruleDateAndTime[0]).format("YYYY-MM-DD");
          ruleEndDate = moment(ruleDateAndTime[1]).format("YYYY-MM-DD");
          list = [
            {
              start: moment(ruleDateAndTime[0]).format("HH:mm:ss"),
              end: moment(ruleDateAndTime[1]).format("HH:mm:ss")
            }
          ];
        }
        for (let i = 0; i < daysList.length; i++) {
          daysList[i] = daysList[i] < 10 ? `0${daysList[i]}` : daysList[i];
        }
        const dateSelectType =
          useImmediately === 0
            ? ruleTimeStrategyType
            : useImmediately === 2
            ? 4
            : "";
        goodsListParams.forEach(v => {
          if (v.attrType == "barcode") {
            v.attrType = "goods";
          }
        })
        console.log("goodsListParams:",goodsListParams);
        let params = {
          operateMemo: this.operateMemo,
          immediatelyType,
          goodsList: goodsListParams,
          addGoodsList: addGoodsListParams,
          smgLabelList: this.smgLabelList,
          sysTag: this.sysTag,
          isPlus: this.target,
          name: this.ruleForm.name,
          type: this.activeTab,
          levelMin: this.ruleForm.levelMin,
          discount: this.ruleForm.discount,
          prefix: this.ruleForm.prefix,
          suffix: this.ruleForm.suffix,
          levelMax: this.activeTab === 1 ? this.ruleForm.levelMax : "",
          ruleStartDate,
          ruleEndDate,
          fetchLimitNum: this.ruleForm.fetchLimitNum,
          useRank: this.useRank,
          ruleTimeStrategyType: dateSelectType,
          day: useImmediately === 0 ? day : "",
          week: useImmediately === 0 ? week.toString() : "",
          daysList: useImmediately === 0 ? daysList.toString() : "",
          perday: useImmediately === 0 ? day : "",
          perweek: useImmediately === 0 ? week.toString() : "",
          permonth: useImmediately === 0 ? daysList.toString() : "",
          useImmediately: useImmediately === 1 || useImmediately === 3 ? 1 : 0,
          imgUrl: this.imgUrl,
          immediatelyEffective:
            useImmediately === 1 || useImmediately === 3
              ? timeType === 0
                ? immediatelyEffective
                : immediatelyEffective
              : "",
          immediatelyEffectiveDays:
            useImmediately === 1 || useImmediately === 3
              ? timeType === 0
                ? immediatelyEffectiveDays
                : immediatelyEffectiveDays
              : "",
          list,
          readme: this.readme,
          icon: "",
          addon: this.addon ? 1 : 0,
          distance: this.distance,
          labelId: this.selectedTag,
          ifSpec: this.ifSpec ? 1 : 0, // 过滤特价商品 1 不过滤 0
          customName: this.ruleForm.customName,
        };
        this.$refs.ruleForm.validate(valid => {
          // 表单验证
          if (valid && this.couponNameError === "") {
            if (
              (this.tabList.length > 0 && this.selectedTag.length > 0) ||
              this.tabList.length <= 0
            ) {
              if (
                ((useImmediately === 1 || useImmediately === 3) &&
                  this.selectedUseInTime &&
                  this.selectedUseInTimeDays &&
                  isRequiredFormat) ||
                (useImmediately === 0 &&
                  this.selectedRuleDate &&
                  this.selectedTimeList &&
                  ((ruleTimeStrategyType === 0 && this.selectedDay) ||
                    (ruleTimeStrategyType === 1 && this.selectedWeek) ||
                    (ruleTimeStrategyType === 2 && this.selectedDaysList))) ||
                (useImmediately === 2 &&
                  ruleStartDate &&
                  ruleEndDate &&
                  list.length > 0)
              ) {
                // 即领即用
                if (this.displayMode === "edit") {
                  params.ruleId = this.$route.query.ruleId;
                  this.$store.dispatch("editNewRules", params);
                } else if (
                  this.displayMode === "add" ||
                  this.displayMode === "copy"
                ) {
                  this.$store.dispatch("setRules", params);
                }
                this.isSaving = true;
              }
            }
          } else {
            return false;
          }
        });
      } else if (this.activeTab == "4") {
        // 不同券传的参数不同
        this.rules.levelMin[0].required =
          this.activeTab === 0 || this.activeTab === 1;
        this.rules.levelMax[0].required = this.activeTab === 1;
        this.rules.discount[0].required = this.activeTab === 1;
        this.rules.account[0].required = this.activeTab !== 1;
        // 获取传入商品
        const hmDateSelect = this.$refs.hmDateSelect;
        // let goodsOfflineList = [];
        // if (this.sysTag === 1) {
        //   goodsOfflineList = this.$refs.serveiceGoods.pickedList;
        // }

        // 获取日期
        const {
          ruleTimeStrategyType,
          day,
          week,
          daysList,
          timeList,
          useImmediately,
          immediatelyEffective,
          immediatelyEffectiveDays,
          ruleDate,
          isRequiredFormat,
          timeType,
          ruleDateAndTime
        } = hmDateSelect;

        let immediatelyType = "";
        if (useImmediately === 3) {
          immediatelyType = "day";
        } else if (useImmediately === 1) {
          immediatelyType = "hour";
        }

        let ruleStartDate = "";
        let ruleEndDate = "";
        let list = [];
        if (useImmediately === 0) {
          ruleStartDate = ruleDate && ruleDate.length > 0 && ruleDate[0];
          ruleEndDate = ruleDate && ruleDate.length > 0 && ruleDate[1];
          // 是否选择中使用日期
          this.selectedRuleDate = ruleDate !== null;
          // 是否选择使用日月周
          this.selectedDay = day !== "" && day > 0;
          this.selectedWeek = week.length > 0;
          this.selectedDaysList = daysList.length > 0;
          // 是否选择中使用时间
          this.selectedTimeList = timeList.length > 0;
          list = timeList;
        } else if (useImmediately === 1 || useImmediately === 3) {
          // 是否选中时间
          this.selectedUseInTime = immediatelyEffective !== "";
          this.selectedUseInTimeDays = immediatelyEffectiveDays !== "";
        } else if (
          useImmediately === 2 &&
          ruleDateAndTime &&
          ruleDateAndTime.length > 0
        ) {
          ruleStartDate = moment(ruleDateAndTime[0]).format("YYYY-MM-DD");
          ruleEndDate = moment(ruleDateAndTime[1]).format("YYYY-MM-DD");
          list = [
            {
              start: moment(ruleDateAndTime[0]).format("HH:mm:ss"),
              end: moment(ruleDateAndTime[1]).format("HH:mm:ss")
            }
          ];
        }
        for (let i = 0; i < daysList.length; i++) {
          daysList[i] = daysList[i] < 10 ? `0${daysList[i]}` : daysList[i];
        }
        const dateSelectType =
          useImmediately === 0
            ? ruleTimeStrategyType
            : useImmediately === 2
            ? 4
            : "";
        let params = {
          operateMemo: this.operateMemo,
          immediatelyType,
          couponLevel: 1,
          smgLabelList: this.smgLabelList,
          sysTag: this.sysTag,
          isPlus: this.target,
          name: this.ruleForm.name,
          type: this.activeTab,
          levelMin: this.ruleForm.levelMin,
          discount: this.ruleForm.discount,
          prefix: this.ruleForm.prefix,
          suffix: this.ruleForm.suffix,
          couponModel: this.ruleForm.couponModel,
          account: this.ruleForm.account,
          levelMax: this.activeTab === 1 ? this.ruleForm.levelMax : "",
          ruleStartDate,
          ruleEndDate,
          fetchLimitNum: this.ruleForm.fetchLimitNum,
          useRank: this.useRank,
          ruleTimeStrategyType: dateSelectType,
          day: useImmediately === 0 ? day : "",
          week: useImmediately === 0 ? week.toString() : "",
          daysList: useImmediately === 0 ? daysList.toString() : "",
          perday: useImmediately === 0 ? day : "",
          perweek: useImmediately === 0 ? week.toString() : "",
          permonth: useImmediately === 0 ? daysList.toString() : "",
          useImmediately: useImmediately === 1 || useImmediately === 3 ? 1 : 0,
          imgUrl: this.imgUrl,
          immediatelyEffective:
            useImmediately === 1 || useImmediately === 3
              ? timeType === 0
                ? immediatelyEffective
                : immediatelyEffective
              : "",
          immediatelyEffectiveDays:
            useImmediately === 1 || useImmediately === 3
              ? timeType === 0
                ? immediatelyEffectiveDays
                : immediatelyEffectiveDays
              : "",
          list,
          readme: this.readme,
          icon: "",
          addon: this.addon ? 1 : 0,
          distance: this.distance,
          labelId: this.selectedTag,
          ifSpec: this.ifSpec ? 1 : 0, // 过滤特价商品 1 不过滤 0
          customName: this.ruleForm.customName,
        };
        this.$refs.ruleForm.validate(valid => {
          // 表单验证
          if (valid && this.couponNameError === "") {
            if (
              (this.tabList.length > 0 && this.selectedTag.length > 0) ||
              this.tabList.length <= 0
            ) {
              if (
                ((useImmediately === 1 || useImmediately === 3) &&
                  this.selectedUseInTime &&
                  this.selectedUseInTimeDays &&
                  isRequiredFormat) ||
                (useImmediately === 0 &&
                  this.selectedRuleDate &&
                  this.selectedTimeList &&
                  ((ruleTimeStrategyType === 0 && this.selectedDay) ||
                    (ruleTimeStrategyType === 1 && this.selectedWeek) ||
                    (ruleTimeStrategyType === 2 && this.selectedDaysList))) ||
                (useImmediately === 2 &&
                  ruleStartDate &&
                  ruleEndDate &&
                  list.length > 0)
              ) {
                // 即领即用
                if (this.displayMode === "edit") {
                  params.ruleId = this.$route.query.ruleId;
                  this.$store.dispatch("editNewRules", params);
                } else if (
                  this.displayMode === "add" ||
                  this.displayMode === "copy"
                ) {
                  this.$store.dispatch("setRules", params);
                }
                this.isSaving = true;
              }
            }
          } else {
            return false;
          }
        });
      } else if (this.activeTab == "5") {
        // 不同券传的参数不同
        this.rules.levelMin[0].required =
          this.activeTab === 0 || this.activeTab === 1 || this.activeTab === 5;
        this.rules.levelMax[0].required = this.activeTab === 1;
        this.rules.discount[0].required = this.activeTab === 1;
        this.rules.account[0].required = this.activeTab !== 1;
        // 获取传入商品
        const hmDateSelect = this.$refs.hmDateSelect;
        let goodsOfflineList = [];
        if (this.sysTag === 1) {
          goodsOfflineList = this.$refs.serveiceGoods.pickedList;
        }
        // 获取日期
        const {
          ruleTimeStrategyType,
          day,
          week,
          daysList,
          timeList,
          useImmediately,
          immediatelyEffective,
          immediatelyEffectiveDays,
          ruleDate,
          isRequiredFormat,
          timeType,
          ruleDateAndTime
        } = hmDateSelect;

        let immediatelyType = "";
        if (useImmediately === 3) {
          immediatelyType = "day";
        } else if (useImmediately === 1) {
          immediatelyType = "hour";
        }

        let ruleStartDate = "";
        let ruleEndDate = "";
        let list = [];
        if (useImmediately === 0) {
          ruleStartDate = ruleDate && ruleDate.length > 0 && ruleDate[0];
          ruleEndDate = ruleDate && ruleDate.length > 0 && ruleDate[1];
          // 是否选择中使用日期
          this.selectedRuleDate = ruleDate !== null;
          // 是否选择使用日月周
          this.selectedDay = day !== "" && day > 0;
          this.selectedWeek = week.length > 0;
          this.selectedDaysList = daysList.length > 0;
          // 是否选择中使用时间
          this.selectedTimeList = timeList.length > 0;
          list = timeList;
        } else if (useImmediately === 1 || useImmediately === 3) {
          // 是否选中时间
          this.selectedUseInTime = immediatelyEffective !== "";
          this.selectedUseInTimeDays = immediatelyEffectiveDays !== "";
        } else if (
          useImmediately === 2 &&
          ruleDateAndTime &&
          ruleDateAndTime.length > 0
        ) {
          ruleStartDate = moment(ruleDateAndTime[0]).format("YYYY-MM-DD");
          ruleEndDate = moment(ruleDateAndTime[1]).format("YYYY-MM-DD");
          list = [
            {
              start: moment(ruleDateAndTime[0]).format("HH:mm:ss"),
              end: moment(ruleDateAndTime[1]).format("HH:mm:ss")
            }
          ];
        }
        for (let i = 0; i < daysList.length; i++) {
          daysList[i] = daysList[i] < 10 ? `0${daysList[i]}` : daysList[i];
        }
        const dateSelectType =
          useImmediately === 0
            ? ruleTimeStrategyType
            : useImmediately === 2
            ? 4
            : "";
        goodsListParams.forEach(v => {
          if (v.attrType == "barcode") {
            v.attrType = "goods";
          }
        })
        console.log("goodsListParams:",goodsListParams);
        // 获取是否plus会员
        // 设置传输参数
        let params = {
          operateMemo: this.operateMemo,
          immediatelyType,
          goodsList: goodsListParams,
          addGoodsList: addGoodsListParams,
          goodsOfflineList,
          smgLabelList: this.smgLabelList,
          sysTag: this.sysTag,
          isPlus: this.target,
          name: this.ruleForm.name,
          type: this.activeTab,
          useNumLimit: this.ruleForm.useNumLimit,
          useAmountLimit: this.ruleForm.useAmountLimit,
          levelMin: this.ruleForm.levelMin,
          account: this.ruleForm.account,
          prefix: this.ruleForm.prefix,
          suffix: this.ruleForm.suffix,
          couponLevel: this.ruleForm.couponLevel,
          levelMax: this.activeTab === 1 ? this.ruleForm.levelMax : "",
          ruleStartDate,
          ruleEndDate,
          fetchLimitNum: this.ruleForm.fetchLimitNum,
          useRank: this.useRank,
          discount: this.activeTab === 1 ? this.ruleForm.discount : "",
          ruleTimeStrategyType: dateSelectType,
          day: useImmediately === 0 ? day : "",
          week: useImmediately === 0 ? week.toString() : "",
          daysList: useImmediately === 0 ? daysList.toString() : "",
          perday: useImmediately === 0 ? day : "",
          perweek: useImmediately === 0 ? week.toString() : "",
          permonth: useImmediately === 0 ? daysList.toString() : "",
          useImmediately: useImmediately === 1 || useImmediately === 3 ? 1 : 0,
          imgUrl: this.imgUrl,
          immediatelyEffective:
            useImmediately === 1 || useImmediately === 3
              ? timeType === 0
                ? immediatelyEffective
                : immediatelyEffective
              : "",
          immediatelyEffectiveDays:
            useImmediately === 1 || useImmediately === 3
              ? timeType === 0
                ? immediatelyEffectiveDays
                : immediatelyEffectiveDays
              : "",
          list,
          readme: this.readme,
          icon: "",
          addon: this.addon ? 1 : 0,
          distance: this.distance,
          labelId: this.selectedTag,
          ifSpec: this.ifSpec ? 1 : 0, // 过滤特价商品 1 不过滤 0
          customName: this.ruleForm.customName,
        };
        this.$refs.ruleForm.validate(valid => {
          // 表单验证
          if (valid && this.couponNameError === "") {
            if (
              (this.tabList.length > 0 && this.selectedTag.length > 0) ||
              this.tabList.length <= 0
            ) {
              if (
                ((useImmediately === 1 || useImmediately === 3) &&
                  this.selectedUseInTime &&
                  this.selectedUseInTimeDays &&
                  isRequiredFormat) ||
                (useImmediately === 0 &&
                  this.selectedRuleDate &&
                  this.selectedTimeList &&
                  ((ruleTimeStrategyType === 0 && this.selectedDay) ||
                    (ruleTimeStrategyType === 1 && this.selectedWeek) ||
                    (ruleTimeStrategyType === 2 && this.selectedDaysList))) ||
                (useImmediately === 2 &&
                  ruleStartDate &&
                  ruleEndDate &&
                  list.length > 0)
              ) {
                console.log("params: ", params);
                // 即领即用;
                if (this.displayMode === "edit") {
                  params.ruleId = this.$route.query.ruleId;
                  this.$store.dispatch("editNewRules", params);
                } else if (
                  this.displayMode === "add" ||
                  this.displayMode === "copy"
                ) {
                  this.$store.dispatch("setRules", params);
                }
                this.isSaving = true;
              }
            }
          } else {
            return false;
          }
        });
      }
    },
    save() {
      if (this.displayMode === "edit") {
        this.sendSaveRequest();
      } else {
        this.$store
          .dispatch("checkRuleValidBySubmit", {
            name: this.ruleForm.name
          })
          .then(res => {
            if (res.result > 0) {
              // 不可用
              this.couponNameError = "已有该券名,请重新设置";
              this.$message({
                message: "已有该券名,请重新设置！",
                type: "warning"
              });
              this.$store.commit("checkRuleValidBySubmit", "");
            } else if (res.result === 0) {
              this.sendSaveRequest();
              this.$store.commit("checkRuleValidBySubmit", "");
            }
          });
      }
    },
    getCurrentRef(ref) {
      if (ref !== "reset") {
        this.$refs[ref].isPreview = true;
      }
    },
    // 移除上传文件
    handleRemove() {
      this.imgUrl = "";
      // this.$message({
      //   type: 'success',
      //   message: '移除成功！'
      // })
    },
    // 上传成功后的回调
    uploadSuccess(response) {
      this.imgUrl = response.result;
      this.$message({
        type: "success",
        message: "上传成功！"
      });
      this.isSaving = false;
    },
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
      this.isSaving = false;
    },
    // 正在上传
    uploading() {
      this.isSaving = true;
    },
    // 上传前对文件的大小的判断
    beforeAvatarUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      const limitSize = file.size / 1024 <= 100;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      if (!limitSize) {
        this.$message({
          message: "上传模板大小不能超过 100k!",
          type: "warning"
        });
      }
      return (extension || extension2 || extension3 || extension4) && limitSize;
    },
    switchUseImmediately(val) {
      // 切换使用类型
      setTimeout(() => {
        const {
          ruleDate,
          timeList,
          ruleDateAndTime,
          immediatelyEffectiveDays
        } = this.$refs.hmDateSelect;
        // 选择非全时段

        if (timeList.length > 0) {
          if (val === 1) {
            this.invalidTime = "1小时后";
            this.residueTime = "01:00:00";
          } else if (val === 0) {
            let endDateList = [];
            if (ruleDate) {
              endDateList = timeList.map(v =>
                moment(`${ruleDate[1]} ${v.end}`).valueOf()
              );
              const maxEndDate = Math.max(...endDateList);
              const endDate = moment(maxEndDate).format("YYYY-MM-DD HH:mm:ss");
              this.invalidTime = immediatelyEffectiveDays;
              this.residueTime = getDateDiff(immediatelyEffectiveDays);
            }
          }
        }
        // 选择全时段
        if (val === 2) {
          if (ruleDateAndTime) {
            this.invalidTime = moment(ruleDateAndTime[1]).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            this.residueTime = getDateDiff(moment(ruleDateAndTime[1]));
          } else {
            this.invalidTime = moment().format("YYYY-MM-DD") + " 23:59:59";
            this.residueTime = getDateDiff(this.invalidTime);
          }
        }
      }, 1000);
    },
    switchRuleDateAndTime() {
      const { ruleDateAndTime } = this.$refs.hmDateSelect;
      if (ruleDateAndTime) {
        this.invalidTime = moment(ruleDateAndTime[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.residueTime = getDateDiff(moment(ruleDateAndTime[1]));
      }
    },
    switchTimeType(val) {
      // 切换天和小时
      const { immediatelyEffectiveDays } = this.$refs.hmDateSelect;
      const suffix = val === 0 ? "天后" : "小时后";
      if (val === 0) {
        this.residueTime = `${immediatelyEffectiveDays}天00:00:00`;
      } else {
        this.residueTime =
          immediatelyEffectiveDays < 10
            ? `0${immediatelyEffectiveDays}:00:00`
            : `${immediatelyEffectiveDays}:00:00`;
      }
      this.invalidTime =
        immediatelyEffectiveDays === ""
          ? 0 + suffix
          : immediatelyEffectiveDays + suffix;
    },
    switchUseIntime(val) {
      // 切换使用期限
      if (val) {
        const { timeType } = this.$refs.hmDateSelect;
        let suffix = "";
        if (timeType === 0) {
          suffix = "天后";
          this.residueTime = `${val}天00:00:00`;
        } else {
          suffix = "小时后";
          if (val < 10) {
            this.residueTime = `0${val}:00:00`;
          } else if (val >= 10 && val <= 24) {
            this.residueTime = `${val}:00:00`;
          } else if (val > 24) {
            this.residueTime = `${Math.floor(val / 24)}天 ${
              val % 24 < 10 ? "0" + (val % 24) : val % 24
            }:00:00`;
          }
        }
        this.invalidTime = val === "" ? 0 + suffix : val + suffix;
      }
    },
    switchRuleDate(val) {
      // 切换使用类型
      const { timeList } = this.$refs.hmDateSelect;
      if (val) {
        let endDateList = [];
        if (val[1]) {
          endDateList = timeList.map(v =>
            moment(`${val[1]} ${v.end}`).valueOf()
          );
          const maxEndDate = Math.max(...endDateList);
          const endDate = moment(maxEndDate).format("YYYY-MM-DD HH:mm:ss");
          this.invalidTime = endDate;
          this.residueTime = getDateDiff(endDate);
        }
      }
    },
    addUseTime(val) {
      // 添加时间
      const { ruleDate } = this.$refs.hmDateSelect;
      if (val) {
        let endDateList = [];
        if (ruleDate[1]) {
          endDateList = val.map(v =>
            moment(`${ruleDate[1]} ${v.end}`).valueOf()
          );
          const maxEndDate = Math.max(...endDateList);
          const endDate = moment(maxEndDate).format("YYYY-MM-DD HH:mm:ss");
          this.invalidTime = endDate;
          this.residueTime = getDateDiff(endDate);
        }
      }
    },
    deleteUseTime(val) {
      // 删除时间
      const { ruleDate } = this.$refs.hmDateSelect;
      if (val.length > 0) {
        let endDateList = [];
        if (ruleDate[1]) {
          endDateList = val.map(v =>
            moment(`${ruleDate[1]} ${v.end}`).valueOf()
          );
          const maxEndDate = Math.max(...endDateList);
          const endDate = moment(maxEndDate).format("YYYY-MM-DD HH:mm:ss");
          this.invalidTime = endDate;
          this.residueTime = getDateDiff(endDate);
        }
      }
    },
    minimum() {
      this.isCollapse = !this.isCollapse;
    },
    checkCouponNameValid() {
      const name = this.ruleForm.name;
      if (name !== "" && this.displayMode !== "edit") {
        this.couponNameError = "";
        this.$store.dispatch("checkRuleValid", {
          name
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.priview {
  position: relative;
  width: 360px;
  height: 180px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.active {
  background: #71abff;
  color: #fff;
  border-radius: 5px;
}
.title {
  padding: 0.5rem 0;
  font-size: 14px;
  .star {
    color: #f56c6c;
  }
}

strong {
  font-style: normal;
  color: #f56c6c;
}

.card-item {
  margin-bottom: 0.5rem;
}
.get-count {
  margin-right: 2rem;
}
.transfer {
  border: 1px solid #e7e8ec;
  height: 485px;
  width: 500px;
  border-radius: 5px;
}
.transfer-header {
  padding: 10px;
  background: #ecf2ff;
  border-radius: 5px 5px 0 0;
}
.transfer-body {
  padding: 10px;
  border-radius: 0 0 5px 5px;
  height: 403px;
  overflow-y: scroll;
}
.control {
  margin: 0 2rem;
  .el-button {
    margin: 0.5rem;
  }
}
.check-wrapper {
  height: 2rem;
  font-size: 14px;
}

.unit {
  margin-left: 0.5rem;
}
.form-tip {
  font-size: 12px;
  color: #999;
  margin-left: 0.5rem;
}
.error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}

.goods-picker {
  width: 30%;
  border: 1px solid #e7e8ec;
  border-radius: 5px;
  overflow-y: hidden;
}

.preview-wrapper {
  position: fixed;
  top: 100px;
  right: 30px;
  width: 365px;
  z-index: 10;
}

.coupon-template {
  background-image: url("https://imgcdn.hemiao100.com/hemiaoBase/594db213-bcac-4e22-9df6-67832e131686.png");
  margin: 20px 20px 0;
  background-repeat: no-repeat;
  background-size: 100%;
  padding: 100px 16px;
  box-sizing: border-box;
  width: 375px;
  user-select: none;
  cursor: move;
  .phone-container {
    background: #fff;
    height: 595px;
    .phone-header {
      height: 44px;
      background: #fff;
      border-bottom: 1px solid #eeeeee;
      padding: 0 10px;
      span {
        flex: 1;
      }
      .title {
        text-align: center;
        color: #333;
        font-size: 1.2rem;
      }
      .setting {
        text-align: right;
      }
    }
    .phone-body {
      background: #f4f4f4;
      height: calc(100% - 45px);
      box-sizing: border-box;
      padding: 10px;
    }
  }
  .coupon {
    border-radius: 5px;
    box-shadow: 0 0 30px rgba(255, 255, 255, 0.1);
    margin-bottom: 10px;
    overflow: hidden;
    width: 100%;
    word-break: break-all;
  }
  .counpon-describe {
    background: #fff;
    padding: 0.625rem;
    flex: 1;
  }
  .coupon-amount {
    position: relative;
    background-image: linear-gradient(90deg, #ff415e, #ff6456);
    color: #fff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 10px;
    width: 100px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .plus {
      position: absolute;
      bottom: 0;
      left: 0;
      color: #fff;
      background: #000;
      border-radius: 30px;
      padding: 0 5px;
      font-size: 0.7rem;
    }
  }

  .coupon-detail {
    border-top: 1px dashed #e8e8e8;
    padding-top: 0.625rem;
    color: #bababa;
    font-size: 0.75rem;
  }
  .price {
    font-size: 1.8rem;
    font-weight: bold;
  }
  .coupon-name {
    font-size: 10px;
    font-weight: bold;
  }
  .hollow-button {
    border-radius: 50px;
    box-sizing: border-box;
    width: 40px;
    color: #ff5972;
    border: 1px solid #ff5972;
    text-align: center;
    font-size: 0.8rem;
    padding: 3px 5px;
  }
  .coupon-amount:before,
  .coupon-amount:after {
    position: absolute;
    content: "";
    width: 10px;
    height: 10px;
    background: #f7f7f7;
    border-radius: 50%;
    left: 94px;
  }
  .coupon-amount:before {
    top: -0.5rem;
  }
  .coupon-amount:after {
    bottom: -0.5rem;
  }
  .invalid-time {
    font-size: 0.75rem;
    color: #bfbfbf;
    margin: 0.625rem 0;
  }
  .residue-time {
    font-size: 0.75rem;
    color: #ff8397;
  }
  .time {
    padding-right: 10px;
  }
  .amount {
    margin-bottom: 0.625rem;
  }
  .coupon-time {
    margin-bottom: 0.625rem;
  }

  .icon-wrapper {
    text-align: right;
    .hmicon {
      font-size: 1.2rem;
      color: #ff5972;
    }
  }

  .discount {
    .hollow-button {
      color: #fea100;
      border: 1px solid currentColor;
    }
    .coupon-amount {
      color: #fff;
      background-image: linear-gradient(to right, #fea100, #feba02);
    }
    .counpon-title {
      color: #feb602;
    }
  }
  .freight {
    .hollow-button {
      color: #5bc1a7;
      border: 1px solid currentColor;
    }
    .coupon-amount {
      color: #fff;
      background-image: linear-gradient(to right, #5bc1a7, #76c8d2);
    }
    .counpon-title {
      color: #5bc1a7;
    }
  }
  .currency,
  .logo {
    margin-top: 5px;
  }
}
.preview-button {
  .arrow {
    display: inline-block;
    transform: rotate(90deg);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.el-upload__tip {
  margin-top: 0;
  margin-left: 2rem;
  color: #999;
  line-height: 2;
}

.tag-wrapper {
  .title {
    color: #999;
    margin: 10px 0;
  }
  .label-list {
    .label-item {
      cursor: pointer;
      padding: 0 10px;
      height: 32px;
      line-height: 30px;
      font-size: 12px;
      border-radius: 4px;
      box-sizing: border-box;
      border: 1px dashed rgba(64, 158, 255, 0.2);
      white-space: nowrap;
      display: inline-block;
      margin-right: 10px;
      user-select: none;
    }
    .label-item:active {
      background-color: rgba(64, 158, 255, 0.1);
      color: #409eff;
    }
    .label-item.disabled {
      cursor: not-allowed;
    }
  }
}
.hm-form-container {
  margin: 0 0 0.5rem;
  padding: 10px;
  border: 1px solid #e7e8ec;
  border-radius: 5px;
}
</style>
